import React, { useState } from "react";
import { SiYoutube } from "react-icons/si";
import { YoutubeModal } from "./YoutubeModal";

const YoutubeIconComponent = SiYoutube as React.FC<React.SVGProps<SVGSVGElement>>;

interface Service {
  name: string;
  text: string;
  videoId: string;
}

interface ServicesProps {
  data?: Service[];
}

// Color palette for cards (repeating pattern)
const cardColors = [
  '#b8d4e8', // Light blue
  '#fef5e7', // Cream
  '#a8dcd1', // Light cyan
];

export const Services: React.FC<ServicesProps> = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [videoId, setVideoId] = useState<string>("");

  const handleClose = () => setShowModal(false);
  const handleShow = (videoId: string) => {
    setVideoId(videoId);
    setShowModal(true);
  };

  // Get color with alternating forward/backward pattern
  const getCardColor = (index: number) => {
    const cycleLength = cardColors.length * 2; // 6 for 3 colors (forward + backward)
    const positionInCycle = index % cycleLength;
    
    if (positionInCycle < cardColors.length) {
      // Forward: 0,1,2
      return cardColors[positionInCycle];
    } else {
      // Backward: 2,1,0
      return cardColors[cycleLength - positionInCycle - 1];
    }
  };

  return (
    <div id="guide" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <h2 className="services-title">
            <span className="services-title-endo">Empieza por aquí</span>
          </h2>
          <p className="services-subtitle">
            Esta es la guía <strong>básica</strong> de endometriosis que estabas buscando.
          </p>
        </div>
        <div className="services-grid">
          {props.data
            ? props.data.map((d, i) => (
              <div 
                key={`${d.name}-${i}`} 
                className="service-card"
                style={{ backgroundColor: getCardColor(i) }}
                onClick={() => handleShow(d.videoId)}
              >
                <div className="service-card-inner">
                  <div className="service-thumbnail">
                    <img
                      src={`https://img.youtube.com/vi/${d.videoId}/maxresdefault.jpg`}
                      alt={`Thumbnail for ${d.name}`}
                      className="service-thumbnail-img"
                    />
                    <div className="service-play-overlay">
                      <YoutubeIconComponent className="service-play-icon" />
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-name">{d.name}</h3>
                    <p className="service-text">{d.text}</p>
                  </div>
                </div>
              </div>
            ))
            : <div className="services-loading">Cargando...</div>}
        </div>
      </div>
      <YoutubeModal show={showModal} onHide={handleClose} videoId={videoId} />
    </div>
  );
};